/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCircuitDiode = createReactComponent("outline", "circuit-diode", "IconCircuitDiode", [["path", { "d": "M22 12h-6", "key": "svg-0" }], ["path", { "d": "M2 12h6", "key": "svg-1" }], ["path", { "d": "M8 7l8 5l-8 5z", "key": "svg-2" }], ["path", { "d": "M16 7v10", "key": "svg-3" }]]);

export { IconCircuitDiode as default };
//# sourceMappingURL=IconCircuitDiode.mjs.map
